import { makeStyles } from '@material-ui/core';

// Collapsed-sidebar mark. Uses the EverDriven location-pin (the same shape as
// the site favicon) rather than the full wordmark so it stays legible at small
// size. Rendered in the pin's brand blue #1B6EC8 (the everdriven favicon color)
// by operator choice for brand fidelity. This is ~2.51:1 on the navy sidebar,
// below the WCAG UI threshold, but a brand logo is exempt from 1.4.3, so the
// brand color is kept intentionally over the higher-contrast white.
const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#1B6EC8',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        className={classes.path}
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </svg>
  );
};

export default LogoIcon;
